import { render, staticRenderFns } from "./privacyOther.vue?vue&type=template&id=ea2d9e66&scoped=true&"
import script from "./privacyOther.vue?vue&type=script&lang=js&"
export * from "./privacyOther.vue?vue&type=script&lang=js&"
import style0 from "./privacyOther.vue?vue&type=style&index=0&id=ea2d9e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2d9e66",
  null
  
)

export default component.exports